import React, { useState } from 'react'

import Modal from 'components/display/Modal'
import FadeIn from 'components/display/FadeIn'
import MobileViewToggle from 'search/filters/mobile/MobileViewToggle'

type MapModalProps = {
  mapComponent: React.ReactNode
}

const MapModal = ({ mapComponent }: MapModalProps) => {
  const [showMap, setShowMap] = useState(false)
  const [hasToggledMap, setHasToggledMap] = useState(false)

  const handleOpenMap = () => {
    setHasToggledMap(true)
    setShowMap(true)
  }

  const handleCloseMap = () => setShowMap(false)

  return (
    <>
      <MobileViewToggle onClick={handleOpenMap} mapOpen={false} />

      <Modal isOpen={showMap} className="c-fullscreen-modal__content">
        {hasToggledMap && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            }}
          >
            <FadeIn style={{ height: '100%', width: '100%' }} $show={showMap}>
              {mapComponent}
            </FadeIn>
          </div>
        )}
        <MobileViewToggle onClick={handleCloseMap} mapOpen />
      </Modal>
    </>
  )
}

export default MapModal
